import SidForm from './SidForm'
import ContactForm from './ContactForm'

/**
 * Container per i form di gestione dei certificati e delle informazioni di contatto
 * per un soggetto CORA o CRS.
 *
 * @param {boolean} disabled - Flag che indica se le modifiche sono disabilitate
 * @param {boolean} archived - Flag che indica se il soggetto è archiviato
 * @param {object} sizes - Oggetto che contiene la larghezza che devono avere i campi del form
 * @param {object} errors - Oggetto degli errori.
 * @param {string} nameApplication - Nome della applicazione.
 * @param {object} subject - Oggetto del soggetto.
 * @param {string} defaultEmail - Indirizzo email di default.
 * @param {object} coraSubjectSid - Sid del soggetto CORA (modificato).
 * @param {object} initialCoraSubjectSid - Sid del soggetto CORA (iniziale).
 * @param {object} certificateFiles - File dei certificati.
 * @param {string} fiscalCode - Codice fiscale del soggetto.
 * @param {function} setCertificateFiles - Funzione per aggiornare i file dei certificati.
 * @param {function} setIsCertSidOpened - Funzione per aggiornare lo stato dell'apertura del form sid.
 * @param {function} setIsCertSidOpened - Funzione per aggiornare lo stato dell'apertura del form sid.
 * @param {function} setErrorCertificates - Funzione per aggiornare gli errori dei certificati.
 * @param {function} checkSid - Funzione per controllare la validita' del sid.
 * @param {function} saveSubject - Funzione per salvare il soggetto.
 * @param {function} handleChangeSid - Funzione che controlla se i campi del sid sono validi e li aggiorna.
 * @param {function} handleChangeSidValues - Funzione per aggiornare i valori del campo sid.
 */
function SidContactFormContainer(props) {
  return (
    <div key={`certificati-${props.subject?.id || 0}`}>
      <SidForm {...props} />
      <ContactForm {...props} />
    </div>
  )
}

export default SidContactFormContainer
